import { render } from "./AposLogoIcon.vue?vue&type=template&id=730602af"
const script = {}

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"schema/ui/apos/components/AposLogoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "730602af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('730602af', __exports__)) {
    api.reload('730602af', __exports__)
  }
  
  module.hot.accept("./AposLogoIcon.vue?vue&type=template&id=730602af", () => {
    api.rerender('730602af', render)
  })

}


export default __exports__